import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';


import {SERVER_API_URL} from "../../app.constants";
import {createRequestOption} from "../../shared/util/request-util";
import {ICustomerDTO} from "../../shared/model/customerDTO.model";
type EntityResponseType = HttpResponse<ICustomerDTO>;
type EntityArrayResponseType = HttpResponse<ICustomerDTO[]>;

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Injectable({providedIn: 'root'})
export class CustomerDTOService {
  public resourceUrl = SERVER_API_URL + 'api/customers-users';

  constructor(protected http: HttpClient) {
  }

  create(customer: ICustomerDTO): Observable<EntityResponseType> {
    return this.http.post<ICustomerDTO>(this.resourceUrl, customer, {observe: 'response'});
  }

  update(customer: ICustomerDTO): Observable<EntityResponseType> {
    return this.http.put<ICustomerDTO>(this.resourceUrl, customer, {observe: 'response'});
  }


  find(id: number): Observable<EntityResponseType> {
    return this.http.get<ICustomerDTO>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ICustomerDTO[]>(this.resourceUrl, {params: options, observe: 'response'});
  }

  getCustomerNotification(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ICustomerDTO[]>(this.resourceUrl + '-notifications', {params: options, observe: 'response'});
  }

  search(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ICustomerDTO[]>(this.resourceUrl + '-search', {params: options, observe: 'response'});
  }


  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  // getOrderHistory(orderObjectId: any): Observable<HttpResponse<any>>{
  //   return this.http.get(`${this.resourceUrl + '/project-history'}/${orderObjectId}`, {observe: 'response'});
  // }


  // public exportAsExcelFile(json: any[], excelFileName: string): void {
  // }

  // public exportAsExcelFile2(json: Customer[], excelFileName: string): void {
  // }
  //
  // private saveAsExcelFile(buffer: any, fileName: string): void {
  //   const data: Blob = new Blob([buffer], {
  //     type: EXCEL_TYPE
  //   });
  // }

}
